import { telegramBotName, telegramWebAppName } from "@/config";
import { Address } from "@ton/core";

export const pathSeparator = "xXXx";
export const refPrefix = "zZZz";
export const miniappUrlParamSeparator = "wWWwW";
export const queryParamPrefix = "qQQq"; // For encoding query params like key=value
export const root_url = `https://t.me/${telegramBotName}/${telegramWebAppName}?startapp=`;

// Call to generate link
export function generateMiniAppParam(
  path: string,
  ref?: string,
  queryParams?: Record<string, string>
) {
  let url_param = path.replace(/\//g, pathSeparator); // Replace all '/' with separator

  if (ref) {
    url_param = url_param + `${miniappUrlParamSeparator}ref${refPrefix}${ref}`; // Append ref if present
  }

  // Append additional query params
  if (queryParams) {
    Object.entries(queryParams).forEach(([key, value]) => {
      url_param =
        url_param +
        `${miniappUrlParamSeparator}${key}${queryParamPrefix}${value}`;
    });
  }

  return url_param;
}

export function generateMiniAppCustomUrl(
  path: string,
  ref?: string,
  queryParams?: Record<string, string>
) {
  return `${root_url}${generateMiniAppParam(path, ref, queryParams)}`;
}

// Call to use link

// https://t.me/Tgstarmaptester_bot/TestStarGame?startapp=hello

export function getUrlFromMiniAppParam(param: string): string {
  if (!param) return "";
  const paramStr = param.split(miniappUrlParamSeparator); // Split by separator

  // Replace path separator with "/"
  let url = paramStr[0].replace(new RegExp(pathSeparator, "g"), "/");

  // Process additional params (ref and query params)
  const queryParts: string[] = [];

  for (let i = 1; i < paramStr.length; i++) {
    const part = paramStr[i];

    if (part.startsWith(`ref${refPrefix}`)) {
      // Handle ref parameter
      const refValue = part.replace(`ref${refPrefix}`, "");
      queryParts.push(`ref=${refValue}`);
    } else if (part.includes(queryParamPrefix)) {
      // Handle other query params (key=value format)
      const [key, value] = part.split(queryParamPrefix);
      if (key && value !== undefined) {
        queryParts.push(`${key}=${value}`);
      }
    }
  }

  // Append query string if we have params
  if (queryParts.length > 0) {
    url += "?" + queryParts.join("&");
  }

  return url;
}

export function recoverRefParam(url: string) {
  // Ищем ?ref=... или &ref=..., затем захватываем значение до следующего & или конца строки
  let parts = url.split("%3F");
  if (parts.length === 1) {
    parts = url.split("?");
  }
  if (parts.length === 1) {
    return null;
  }
  const match = parts[1].split("=");
  // console.log("M:", match)
  return match.length > 1 ? match[1] : null;
}
